var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { withLatestFrom, switchMap } from 'rxjs/operators';
import { CustomersApi } from '@careapp/angular-sdk';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CustomerTeam } from '../actions/index';
import * as selectors from '../reducers/index';
var of = Observable.of;
var CustomerTeamEffects = /** @class */ (function () {
    function CustomerTeamEffects(store, actions$, customerApi) {
        var _this = this;
        this.store = store;
        this.actions$ = actions$;
        this.customerApi = customerApi;
        this.fetchCustomerTeam = this.actions$
            .ofType(CustomerTeam.REQUEST_ALL).pipe(withLatestFrom(this.store.select(selectors.getSelectedId('customers'))), switchMap(function (_a) {
            var action = _a[0], id = _a[1];
            return _this.customerApi
                .listTeam(id)
                .map(function (res) { return CustomerTeam.ResponseSuccessAllAction(res); })
                .catch(function (err) { return of(CustomerTeam.ResponseFailAllAction(err)); });
        }));
        this.addTeam = this.actions$
            .ofType(CustomerTeam.REQUEST_CREATE).pipe(withLatestFrom(this.store.select(selectors.getSelectedId('customers'))), switchMap(function (_a) {
            var action = _a[0], id = _a[1];
            return _this.customerApi
                .addTeam(id, action.payload.staff.id, action.payload.role)
                .map(function (res) { return CustomerTeam.ResponseSuccessCreateAction(res); })
                .catch(function (err) { return of(CustomerTeam.ResponseFailCreateAction(err)); });
        }));
        this.removeTeam = this.actions$
            .ofType(CustomerTeam.REQUEST_REMOVE).pipe(withLatestFrom(this.store.select(selectors.getSelectedId('customers'))), switchMap(function (_a) {
            var action = _a[0], id = _a[1];
            return _this.customerApi
                .removeTeam(id, action.payload.id)
                .map(function (res) { return CustomerTeam.ResponseSuccessRemove({ id: action.payload.id, customerId: id }); })
                .catch(function (err) { return of(CustomerTeam.ResponseFailRemove(err)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], CustomerTeamEffects.prototype, "fetchCustomerTeam", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], CustomerTeamEffects.prototype, "addTeam", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], CustomerTeamEffects.prototype, "removeTeam", void 0);
    return CustomerTeamEffects;
}());
export { CustomerTeamEffects };
